var _path, _path2, _path3, _path4;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconIdea = function SvgIconIdea(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlSpace: "preserve",
    enableBackground: "new 0 0 64 64",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.573 21.833H4.05M59.853 21.833h-6.276M52.099 1.686l-4.053 4.053M11.706 1.588l4.053 4.053",
    fill: "none",
    stroke: "#05ac5d",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    className: "stroke-27aae1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m25.957 45.06-1.646-1.646c-.777-.778-1.413-2.314-1.413-3.414v-1.502c0-1.1-.735-2.519-1.634-3.153 0 0-6.457-4.557-6.457-13.32C14.807 12.623 22.429 5 31.832 5c9.403 0 17.025 7.623 17.025 17.025 0 8.762-6.457 13.32-6.457 13.32-.899.634-1.634 2.053-1.634 3.153V40c0 1.1-.636 2.636-1.414 3.414l-1.461 1.461",
    fill: "none",
    stroke: "#231f20",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    className: "stroke-231f20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.017 45h1a2 2 0 0 1 2 2h0a2 2 0 0 1-2 2h-10a2 2 0 0 1-2-2h0a2 2 0 0 1 2-2H35.5M37.017 49a2 2 0 0 1 2 2h0a2 2 0 0 1-2 2h-10a2 2 0 0 1-2-2h0a2 2 0 0 1 2-2M37.017 53a2 2 0 0 1 2 2h0a2 2 0 0 1-2 2h-10a2 2 0 0 1-2-2h0a2 2 0 0 1 2-2M35.017 57.5a3 3 0 1 1-6 0",
    fill: "none",
    stroke: "#231f20",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    className: "stroke-231f20"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.054 40V22.111a3.111 3.111 0 1 0-3.111 3.111l3.111.194M33.61 40V22.111a3.111 3.111 0 1 1 3.111 3.111l-3.111-.192M12.399 13.187l-5.965-2.639M57.469 33.118l-5.74-2.538M51.503 13.187l5.966-2.639M6.434 33.118l5.74-2.538",
    fill: "none",
    stroke: "#05ac5d",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    className: "stroke-27aae1"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconIdea, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-idea.91b42e59.svg";
export { ForwardRef as ReactComponent };